import React from 'react';
import useFadeIn from '../hooks/useFadeIn';
import '../css/sections.css';
import { PROFILES } from "../data/profiles";
import { useNavigate } from 'react-router-dom';


// const PROFILES = [
//   {
//     _id: '1',
//     name: 'Dr. Charles NG – Singapore',
//     role: 'Founder, Naturopath & Integrative Skincare Specialist | SkinEthos Clinic',
//     category: 'Healthcare ',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p1.jpeg',
//   },
//   {
//     _id: '2',
//     name: 'Prof. Dr. Carlos Rivas Echeverríai',
//     role: 'Director | Sleep Care Clinics, United Kingdom',
//     category: 'Healthcare ',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p2.jpeg',
//   },
//   {
//     _id: '3',
//     name: 'Dr. Shavonna Herron-Johnson',
//     role: 'CFounder & CEO | East Coast Property Management Services & Consulting',
//     category: 'Automotive',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p3.jpeg',
//   },
//   {
//     _id: '4',
//     name: 'Dr. Shawn Fair – USA',
//     role: 'CEO and Founder | The Leadership Experience Tour',
//     category: 'Technology',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p4.jpeg',
//   },
//   {
//     _id: '5',
//     name: 'H.E. Dr. Theresa A. Moseley',
//     role: 'Owner & CEO | TAM Creating Ambassadors of Peace LLC, USA',
//     category: 'Technology',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p5.jpeg',
//   },
//   {
//     _id: '6',
//     name: 'Sukh Sandhu',
//     role: 'Sukh Sandhu is an internationally recognised compliance strategist, education reformer, and global leadership advocate with over 30 years of experience spanning the VE',
//     category: 'Business',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p6.jpeg',
//   },
//   {
//     _id: '7',
//     name: 'Brigadier General (Ret.) Twanda E. Young',
//     role: ' a senior military executive with 30+ years of service, is now CEO of LT3 Leadership Solutions',
//     category: 'Business',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p7.jpeg',
//   },
//   {
//     _id: '8',
//     name: 'Muhammad Solwa',
//     role: 'Executive Management Professional with over 20 years of expertise in Audit, Risk',
//     category: 'Technology',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p8.jpeg',
//   },
//   {
//     _id: '9',
//     name: 'Manoj Menorn',
//     role: 'As Group CEO of ACCRO, Dr. Menon',
//     category: 'Technology',
//     imageUrl: 'https://devoted-coffee-kvcshgja.edgeone.dev/p9.jpeg',
//   },
// ];

export default function Profiles() {
  const ref = useFadeIn(true);
  const navigate = useNavigate();
  console.log("PROFILES:", PROFILES);
  console.log("Type:", typeof PROFILES);
  console.log("Is Array:", Array.isArray(PROFILES));

  return (
    <section className="sec sec-dark" id="profiles" ref={ref}>
      <div className="wrap">
        <div className="sec-head center">
          <h2 className="sec-title fade-in">Featured Leaders</h2>
          <p className="sec-sub fade-in">
            Meet the visionaries and change-makers featured in our latest editions.
          </p>
        </div>

        {/* FIX #20: CSS uses auto-fill minmax(220px,1fr) → goes 1-col at 420px */}
        <div className="profiles-grid">
          {PROFILES.map((p) => (
            <div
              key={p._id}
              className="profile-card fade-in"
              onClick={() => navigate(`/profile/${p._id}`)}
            >
              <div className="profile-img">
                <img
                  src={p.imageUrl}
                  alt={`Portrait of ${p.name}`}
                  loading="lazy"
                  width="400"
                  height="400"
                  onError={e => {
                    e.target.style.display = 'none';
                    e.target.parentElement.style.background = 'var(--card2)';
                  }}
                />
              </div>
              <div className="profile-body">
                <div className="profile-name">{p.name}</div>
                <div className="profile-role">{p.role}</div>
                <span className="profile-cat">{p.category}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
